import React from 'react';

import {
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import SuraCard from '../../../../components/SuraCard';
import { appConfig } from '../../../../config/app';
import { IncidentsLabels } from '../../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import useLogEventInAnalytics from '../../../../hooks/useLogAnalyticsEvent';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    selectedCard: {
      background: theme.palette.background.default,
    },
  })
);
interface SelectionCardsProps {
  cards: { title: string; icon: any; value: string | number }[];
  relatedField: string;
}

const SelectionCards: React.FC<SelectionCardsProps> = ({
  cards,
  relatedField,
}) => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();
  const classes = useStyle();
  const { user } = useAuthDataContext();
  const { logEvent } = useLogEventInAnalytics();

  const selectCard = (value: string | number) => {
    logEvent(`complaints_${value}`, {
      app: appConfig?.NAME,
    });

    dataLayerPush('siniestro_daños', user?.id, {
      fieldName: 'opcion_siniestro_daños',
      fieldValue: IncidentsLabels[value],
    });

    if (sinister_body.need_assistance === true) {
      dataLayerPush('siniestro_btn_necesitoAsistencia', user?.id);
    }

    updateSinisterBody({
      [relatedField]: value,
    });
    nextStep();
  };

  return (
    <>
      {cards.map((card: any, index: number) => (
        <Grid item xs={12} sm={6} key={index}>
          <Box mr={3} mb={3}>
            <ButtonBase
              style={{ width: '100%' }}
              onClick={() => selectCard(card.value)}
            >
              <SuraCard
                className={
                  sinister_body[relatedField] === card.value
                    ? classes.selectedCard
                    : ''
                }
                style={{ width: '100%' }}
              >
                <Box
                  m={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  width={'100%'}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <img src={card.icon} alt={card.title}></img>
                    </Box>
                    <Box ml={1} textAlign="left">
                      <Typography
                        variant="body1"
                        align="left"
                        color="textPrimary"
                        style={{ fontFamily: 'Inter' }}
                      >
                        {card.title}
                      </Typography>
                      {card.caption && (
                        <Typography
                          variant="caption"
                          // color="secondary"
                          align="left"
                          style={{ fontFamily: 'Inter', color: '#4D4D4D' }}
                        >
                          {card.caption}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box>
                    <RightIcon></RightIcon>
                  </Box>
                </Box>
              </SuraCard>
            </ButtonBase>
          </Box>
        </Grid>
      ))}
    </>
  );
};

export default SelectionCards;
